/*  MUI  */
import { Call, Email, Logout } from '@mui/icons-material';
import { Box, Button, Card, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/*  Shared  */
import { AuvikASMLogo } from 'application/Shared/Components/App/AuvikLogo';
import { FontSizes } from 'application/Shared/Constants';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

const TrialExpiryJailCard = () => {
    const { t } = useTranslation();

    return (
        <Card
            sx={{
                backgroundColor: 'trialExpiryJailCard.cardBackgroundColor',
                borderRadius: '16px',
                width: '600px'
            }}
        >
            <Box textAlign="center" mt={6} mb={3}>
                <AuvikASMLogo />
            </Box>
            <Typography
                variant="body2"
                textAlign="center"
                fontWeight={600}
                mt="12px"
                sx={{
                    color: 'trialExpiryJailCard.title',
                    fontSize: FontSizes[4]
                }}
            >
                {t('TrialExpiryJailPage.title')}
            </Typography>
            <Box p="32px">
                {/* <ViewPricingCard />
            <LabelledHorizontalRule>
                {t('TrialExpiryJailPage.or')}
            </LabelledHorizontalRule> */}
                <ContactCard />
            </Box>
        </Card>
    );
};

// TODO: Remove eslint-disable-next-line when/if we add the pricing page back
// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
const ViewPricingCard = () => {
    const { t } = useTranslation();
    return (
        <Card variant="outlined" p="16px">
            <Box px="32px" py="8px" textAlign="center">
                <Typography
                    variant="body2"
                    mt="8px"
                    mb="24px"
                    textAlign="center"
                    textTransform="uppercase"
                    sx={{ fontSize: FontSizes[3] }}
                >
                    {t('TrialExpiryJailPage.purchaseSubscription')}
                </Typography>
                <Box my="8px">
                    <Link
                        to="/home/viewPricing"
                        data-trackid="trialJailViewPricingLink"
                    >
                        <Button
                            color="primary"
                            variant="contained"
                            data-testid="saaslio-buy-now-button"
                            data-trackid="trialJailViewPricingButton"
                        >
                            {t('TrialExpiryJailPage.viewPricing')}
                        </Button>
                    </Link>
                </Box>
            </Box>
        </Card>
    );
};

const Hr = () => (
    <Box
        borderBottom="2px solid"
        sx={{ borderBottomColor: 'trialExpiryJailCard.divider' }}
        flex={1}
        height="0"
    />
);

// TODO: Remove eslint-disable-next-line when/if we add the pricing page back
// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
const LabelledHorizontalRule = ({ children }) => (
    <Box display="flex" my="32px" alignItems="center">
        <Hr />
        <Typography
            variant="body2"
            marginX="8px"
            textTransform="uppercase"
            sx={{ fontSize: FontSizes[3] }}
        >
            {children}
        </Typography>
        <Hr />
    </Box>
);

const ContactCard = () => {
    const { t } = useTranslation();
    return (
        <Card
            data-testid="contactCard"
            variant="outlined"
            sx={{
                borderColor: 'trialExpiryJailCard.subcardBorderColor',
                margin: 'auto',
                width: '380px'
            }}
        >
            <Box mx="64px" my="16px">
                <Typography
                    variant="body2"
                    textAlign="center"
                    color="trialExpiryJailCard.subtitle"
                    style={{
                        fontSize: FontSizes[3],
                        fontWeight: '600',
                        marginBottom: '24px',
                        marginTop: '8px'
                    }}
                >
                    {t('TrialExpiryJailPage.contactSales')}
                </Typography>
                <Box display="flex" alignItems="center">
                    <Email
                        sx={{
                            color: 'trialExpiryJailCard.icon',
                            fontSize: FontSizes[3],
                            marginRight: '8px'
                        }}
                    />
                    <a
                        href={`mailto:${t('TrialExpiryJailPage.sales.email')}`}
                        data-trackid="trialExpiryJail_mailToSales"
                    >
                        <Typography>
                            {t('TrialExpiryJailPage.sales.email')}
                        </Typography>
                    </a>
                </Box>
                <Box display="flex" mt="8px" alignItems="flex-start">
                    <Call
                        sx={{
                            color: 'trialExpiryJailCard.icon',
                            fontSize: FontSizes[3],
                            marginRight: '8px'
                        }}
                    />
                    <Box>
                        <Typography>
                            {t('TrialExpiryJailPage.main.phone')}
                        </Typography>
                        <Typography mt="8px">
                            {t('TrialExpiryJailPage.phone.north.america')}
                        </Typography>
                        <Typography mt="8px">
                            {t('TrialExpiryJailPage.phone.uk')}
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </Card>
    );
};

const LogoutOption = () => {
    const { t } = useTranslation();
    return (
        <Box padding="64px">
            <Link
                to="/logout"
                data-trackid="trialJailLogoutLink"
                data-testid="trialJailLogoutLink"
                style={{
                    alignItems: 'center',
                    display: 'flex'
                }}
            >
                <Logout
                    sx={{
                        color: 'trialExpiryJailCard.logoutIcon',
                        fontSize: FontSizes[3],
                        marginRight: '8px'
                    }}
                />
                <Typography
                    variant="p"
                    textTransform="uppercase"
                    sx={{
                        color: 'trialExpiryJailCard.logoutText',
                        fontSize: FontSizes[2]
                    }}
                >
                    {t('Common.logout')}
                </Typography>
            </Link>
        </Box>
    );
};

export const TrialExpiryJailPage = () => {
    const theme = useTheme();
    return (
        <Box
            display="flex"
            flexDirection="column"
            height="100%"
            justifyContent="space-between"
            sx={{
                // eslint-disable-next-line max-len
                background: `linear-gradient(${theme.palette.trialExpiryJailCard.backgroundTrialJailGradientStart},${theme.palette.trialExpiryJailCard.backgroundTrialJailGradientEnd})`
            }}
        >
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                width="100%"
                height="100%"
            >
                <Box my="64px" position="relative">
                    <TrialExpiryJailCard />
                </Box>
            </Box>
            <LogoutOption />
        </Box>
    );
};
